import { Text } from '@simplywallst/ui-core';
import { formatterCurrencyTruncated } from '@/utilities/format';
import type { Note } from '@/components/Note/hooks/useNote';

export interface CompanySharePriceProps {
  company?: Note['company'];
}

const CompanySharePrice = ({ company }: CompanySharePriceProps) => {
  if (typeof company !== 'undefined') {
    const currentSharePrice = company.analysisValue.lastSharePrice;
    const currencyISO = company.listingCurrencyISO;

    const formattedSharePrice = formatterCurrencyTruncated(
      currentSharePrice,
      currencyISO,
      2
    );

    return (
      <Text typography="xSmall" color="mediumGray">
        {`Current share price is ${formattedSharePrice}`}
      </Text>
    );
  }

  return (
    <Text typography="xSmall" color="mediumGray">
      Unable to retrieve share price.
    </Text>
  );
};

export default CompanySharePrice;
